import { Col, Row, Sidepanel, Text } from 'components';
import { formatLocale, theme } from 'lib';
import mime from 'mime';
import React from 'react';
import ReactPlayer from 'react-player';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { ContentHeader } from 'screens/Admin/components';

const Section = styled.div`
  padding: 20px 24px 0;
`;

const MediaFrame = styled.div`
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  background: ${theme.GREY_10};
  border: 1px solid ${theme.GREY_20};
`;

const PreviewImage = styled.img`
  width: 100%;
  max-height: 420px;
  object-fit: contain;
  display: block;
`;

const DetailRow = ({ label, value }) => (
  <Col noFlex marg="0 0 16px">
    <Text c1 med col={theme.GREY_60} marg="0 0 4px">
      {label}
    </Text>
    <Text>{value || '-'}</Text>
  </Col>
);

const ShoutoutPanel = ({ dataId, closeModal }) => {
  const shoutout = useSelector((state) => state.admin?.shoutouts?.find((x) => x._id === dataId));
  const mediaType = shoutout?.media?.uri ? mime.getType(shoutout.media.uri) : '';
  const isVideo = mediaType?.includes('video');
  const isAudio = mediaType?.includes('audio');

  return (
    <Sidepanel wid={640} pad="0" visible={dataId} closeModal={closeModal}>
      <ContentHeader
        text={!shoutout ? 'Shoutout details' : `${shoutout?.from?.name || shoutout?.from?.username}'s shoutout`}
        closePanel={closeModal}
      />

      {shoutout && (
        <React.Fragment>
          <Section>
            <Row gap="24px" start>
              <Col noFlex wid="50%">
                <DetailRow
                  label="Owner"
                  value={
                    shoutout?.from?.name
                      ? `${shoutout.from.name} (@${shoutout.from.username || ''})`
                      : shoutout?.from?.username
                  }
                />
                <DetailRow label="Sport" value={shoutout?.sport || '-'} />
                <DetailRow label="Published At" value={formatLocale(new Date(shoutout.createdAt), 'LLL do yyy, hh:mm a')} />
              </Col>

              <Col noFlex wid="50%">
                <DetailRow label="Shoutout For" value={shoutout?.user?.type || '-'} />
                <DetailRow
                  label="Team or Athlete"
                  value={
                    shoutout?.user?.name
                      ? `${shoutout.user.name}${shoutout.user.username ? ` (@${shoutout.user.username})` : ''}`
                      : shoutout?.user?.username || '-'
                  }
                />
                <DetailRow
                  label="Media Type"
                  value={
                    isVideo ? 'Video' : isAudio ? 'Audio' : shoutout?.media?.uri ? 'Image' : 'Text'
                  }
                />
              </Col>
            </Row>
          </Section>

          <Section>
            <Text c1 med col={theme.GREY_60} marg="0 0 8px">
              Message
            </Text>
            <Text style={{ whiteSpace: 'pre-wrap' }}>{shoutout?.comment || '-'}</Text>
          </Section>

          {!!shoutout?.media?.uri && (
            <Section>
              <Text c1 med col={theme.GREY_60} marg="0 0 8px">
                Media
              </Text>
              <MediaFrame>
                {isVideo && <ReactPlayer url={shoutout.media.uri} controls width="100%" height="360px" />}
                {isAudio && (
                  <Col pad="24px">
                    <audio controls src={shoutout.media.uri} style={{ width: '100%' }} />
                  </Col>
                )}
                {!isVideo && !isAudio && (
                  <PreviewImage
                    src={shoutout.media.uri}
                    alt={shoutout.comment || 'Shoutout media'}
                  />
                )}
              </MediaFrame>
            </Section>
          )}
        </React.Fragment>
      )}
    </Sidepanel>
  );
};

export default ShoutoutPanel;
